import { Component, OnInit, TemplateRef, OnDestroy } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";

import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BatchstampService } from "../batchstamp/batchstamp.service";
import { BsModalService } from "ngx-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
declare function baseTracking(appId);
declare function enterScreenView(screenName:any, contentType:any, referrer:any);
declare function visibleContent(regionName:any, contentName:any, index:any);
declare function clickTracking(regionName:any, contentName:any, target:any, payload: any);
declare function alertMsg(alertType:any, alertMessage:any);
declare function searchEvent(keywords:any,params:any,order:any, sort:any)
@Component({
  selector: "cancel-stamp-modal-content",
  templateUrl: "./modalCancelStamp.template.html",
  styles: [`
    .lock-modal-title { font-family: Inter, sans-serif; font-weight: 600; font-size: 18px; color: #374957; margin: 0; }
    .lock-alert { display: flex; align-items: flex-start; gap: 8px; padding: 12px 16px; background: #FEF2F2; border-left: 4px solid #EC5858; margin-bottom: 16px; border-radius: 4px; }
    .lock-alert-text { font-family: Inter, sans-serif; font-weight: 400; font-size: 14px; color: #E7000B; margin: 0; line-height: 1.4; }
    .lock-label { font-family: Inter, sans-serif; font-weight: 600; font-size: 14px; color: #374957; margin-bottom: 8px; display: block; }
    .lock-input { background: #F9FAFB; border: 1px solid #E5E7EB; border-radius: 4px; padding: 8px 12px; width: 100%; color: #5F7D95; font-size: 14px; outline: none; }
    .lock-input:disabled { background: #F9FAFB; cursor: not-allowed; }
    .lock-input:focus { border-color: #007bff; }
    .lock-helper-text { font-family: Inter, sans-serif; font-weight: 400; font-size: 12px; color: #6A7282; margin-bottom: 8px; display: block; }
    .lock-table-input { background: #F9FAFB; border: 1px solid #E5E7EB; color: #5F7D95; font-size: 14px; padding: 8px 12px; outline: none; }
    .lock-table-input:disabled { background: #F9FAFB; color: #5F7D95; }
    .lock-table-input:focus { border-color: #007bff; z-index: 1; }
    .lock-checkbox-row { display: flex; align-items: center; gap: 10px; margin-top: 16px; margin-bottom: 16px; }
    .lock-checkbox-label { font-family: Inter, sans-serif; font-weight: 400; font-size: 14px; color: #374957; margin: 0; cursor: pointer; }
    .lock-contact-row { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: #F9FAFB; border: 1.25px solid #E5E7EB; border-radius: 10px; margin-bottom: 8px; }
    .lock-contact-info { display: flex; align-items: center; gap: 12px; }
    .lock-contact-title { font-family: Inter, sans-serif; font-weight: 600; font-size: 14px; color: #374957; margin: 0; line-height: 1.4; }
    .lock-contact-desc { font-family: Inter, sans-serif; font-weight: 400; font-size: 12px; color: #5F7D95; margin: 0; line-height: 1.4; }
    .lock-btn-cancel { background: #E5E7EB; color: #5F7D95; border-radius: 4px; border: none; padding: 8px 16px; font-weight: 400; font-size: 14px; cursor: pointer; font-family: Inter, sans-serif; }
    .lock-btn-submit { background: #EC5858; color: #FFFFFF; border-radius: 4px; border: none; padding: 8px 16px; font-weight: 400; font-size: 14px; margin-right: 8px; cursor: pointer; font-family: Inter, sans-serif; }
    .switch { position: relative; display: inline-block; width: 34px; height: 20px; margin: 0; }
    .switch input { opacity: 0; width: 0; height: 0; }
    .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #E5E7EB; transition: .4s; border-radius: 34px; }
    .slider:before { position: absolute; content: ""; height: 16px; width: 16px; left: 2px; bottom: 2px; background-color: white; transition: .4s; border-radius: 50%; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
    input:checked + .slider { background-color: #007bff; }
    input:checked + .slider:before { transform: translateX(14px); }
  `],
})
export class ModalCancelStampComponent implements OnInit, OnDestroy {
  batch_detail: any;
  closeBtnName: string;
  private closeBtnNameIsDefault = false;

  public message: any = { type: "", content: "" };
  public FormCancelStamp: FormGroup;
  is_loading = false;
  id_start: any;
  id_end: any;

  data_cancel: any = {};

  is_modal_confirm: boolean = false;
  modalRef2: BsModalRef;

  subcribe: Subscription = null;
  langChangeSub: Subscription = null;

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private batchService: BatchstampService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.subcribe = this.modalService.onHide.subscribe((reason: string) => {
      this.is_modal_confirm = false;
    });
  }

  ngOnInit() {
    // console.log(this.batch_detail);
    this.id_start = this.formatSerialMinSixCharacter(
      this.batch_detail.id_start
    );
    this.id_end = this.formatSerialMinSixCharacter(this.batch_detail.id_end);
    this.createForm();

    if (!this.closeBtnName) {
      this.closeBtnName = this.translate.instant("HUY");
      this.closeBtnNameIsDefault = true;
    }
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      if (this.closeBtnNameIsDefault) {
        this.closeBtnName = this.translate.instant("HUY");
      }
    });
  }
  ngOnDestroy() {
    if (this.subcribe) this.subcribe.unsubscribe();
    if (this.langChangeSub) this.langChangeSub.unsubscribe();
  }

  modalConfirmCancel(data: any, template: TemplateRef<any>) {
    this.data_cancel = data;
    this.is_modal_confirm = true;
    this.modalRef2 = this.modalService.show(template, { class: "second" });
  }

  createForm() {
    this.FormCancelStamp = this.fb.group({
      id_start: [
        { value: this.id_start, disabled: this.batch_detail.readonly },
        [Validators.required],
      ],
      id_end: [
        { value: this.id_end, disabled: this.batch_detail.readonly },
        [Validators.required],
      ],
      reason: [null, [Validators.required]],
      isFake: [false],
      showContactBusiness: [true],
      showContactIcheck: [true],
    });
  }

  parse_int(s) {
    return parseInt(s);
  }

  submitCancelStamp(data) {
    this.is_loading = true;
    // console.log(data);
    let request: any = {};
    if (this.batch_detail.id) {
      request.batch_id = this.batch_detail.id;
    }
    if (this.batch_detail.readonly == true) {
      // cho trường hợp gọi từ log tràn hàng
      request.id_start = parseInt(this.batch_detail.id_start);
      request.id_end = parseInt(this.batch_detail.id_end);
    } else {
      if (data.id_start && data.id_end) {
        request.id_start = parseInt(data.id_start);
        request.id_end = parseInt(data.id_end);
      }
    }

    if (data.reason) {
      request.note = data.reason;
    }

    request.is_fake = data.isFake || false;
    request.show_contact_business = data.showContactBusiness || false;
    request.show_contact_icheck = data.showContactIcheck || false;

    request.status = 1; // =1: thu hoi, =0: phuc hoi

    this.batchService
      .restoreStamp(request)
      .toPromise()
      .then((res: any) => {
        this.is_loading = false;
        if (res.error == false) {
          this.modalRef2.hide();
          this.modalRef2 = null;
          this.bsModalRef.hide();
          this.bsModalRef = null;
          const successMsg = this.translate.instant("YEU_CAU_KHOA_TEM_THANH_CONG");
          this.toastr.success(successMsg, "", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          alertMsg("success", successMsg);
        } else {
          console.log("error:false", res.message);
          let mess = res.message
            ? res.message
            : this.translate.instant("THAO_TAC_KHOA_TEM_KHONG_THANH_CONG_VUI_LONG_THU_LAI_SAU");
          this.toastr.warning(mess, this.translate.instant("THONG_BAO"), {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
          alertMsg("warning", mess);
        }
      })
      .catch((err: any) => {
        this.is_loading = false;
        console.log("catch:", err);
        let mess = err.message
          ? err.message
          : this.translate.instant("THAO_TAC_KHOA_TEM_KHONG_THANH_CONG_VUI_LONG_THU_LAI_SAU");
        this.toastr.error(mess, this.translate.instant("THONG_BAO"), {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
        alertMsg("error", mess);
      });
  }

  formatSerialMinSixCharacter(serial) {
    let serial6char: string = "";
    serial = serial.toString();
    if (serial) {
      let pad = "000000";
      serial6char = pad.substring(0, 6 - serial.length) + serial;
    }
    return serial6char;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/modalCancelStamp.component.ts